/*
 * @Author: your name
 * @Date: 2021-04-23 14:22:56
 * @LastEditTime: 2021-09-23 16:50:00
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\reserveImplement\api\index.js
 */
export const api = {
  alarm: {
    getAlarmDetail: '/bas/alarmSafeEvent/queryResult.json', // 获取告警详情
    getAlarmPageList: '/bas/alarmSafeEvent/queryResultsByPage.json', // 安全事件告警筛选
    updateAlarm: '/bas/alarmSafeEvent/updateSafeEvent.json', // 安全事件告警处理
    missReport: '/bas/alarmSafeEvent/missReport.json'// 误报
  },
  historyAlarm: {
    sreachAlarm: '/bas/safeEvent/sreachAlarmDetails.json' // 历史告警筛选
  },
  bms: {
    getDeviceTypeList: '/bms/device/getDeviceTypeListByPage.json', // 获取设备类型
    // queryMapResource: '/bms/device/queryResource.json' // 返回地图展示的资源数据
    queryMapResource: '/bms/device/queryDeviceListByType.json',
    queryMapResources:'/bms/device/queryMapResources.json',
    queryCameraList:'/bms/device/queryDeviceWorkGroupDeviceTree.json',
  },
  bas: {
    addTaskInfo: '/bas/taskcenter/addTaskInfo.json', // 任务下发
    queryRelevantDevList: '/bas/linkage/queryRelevantDevList.json',
    queryLinkedDevList: '/bas/linkage/queryLinkedDevList.json',
    cancelAssociation: '/bas/linkage/cancelAssociation.json', //
    fastLinkage: '/bas/linkage/fastLinkage.json', // 配置快速联动
    picStreamInfo:'/bas/safeEvent/picStreamInfo.json',
    getBigPicture: '/bas/safeEvent/getPictureStream.json' //获取实时告警抓拍大图(仅人员黑白名单，车辆黑名单)
  },
  cms: {
    queryAccGroup: '/cms/accountGroup/queryResultsByPage.json', // 查询账户组信息
    getArea: '/cms/area/queryAreaByAccountName.json', // 查询关联区域
    getGroups: '/cms/account/queryRlatAcctGroup.json', // 根据账户查账户组
    getAccount: '/cms/accountGroup/getAccountByAccountGroup.json'
  },
  reserve: {
    // 查询预案配置列表
    // getEmergencyPlanListByAlarmType: '/bas/emergency/queryEmergencyPlanList.json',
    getEmergencyPlanListByAlarmType: '/bas/emergency/queryEmergencyPlanListApi.json',
    // 查询预案执行记录详情
    queryEmergencyRecordDetail: 'bas/emergency/queryEmergencyRecordDetail.json',
    // 查询预案执行记录列表
    queryEmergencyRecordList: 'bas/emergency/queryEmergencyRecordList.json',
    // 启动预案
    emergencyResponse: '/bas/emergency/addEmergencyRecord.json',
    // 视频
    queryRealTimeVideoRtsp: '/vas/video/queryRealTimeVideoRtsp.json',
    // add手动预案
    handEmergency: '/bas/emergency/addHandEmergency.json',
    // 预案执行页面左侧列表点击出来的详情面板中的应急响应按钮调的接口
    updateEmergencyRecord: '/bas/emergency/updateEmergencyRecord.json',
    // 获取设备列表
    queryRegionalEquipmentTree: 'vas/video/queryRegionalEquipmentTree.json'
  }
}
